import { filterDiffFunction } from './chunk-WTGT4IDV.mjs';
import { i18n_config_default } from './chunk-EJ2TIXJU.mjs';
import { __spreadProps, __spreadValues } from './chunk-T36PI2YV.mjs';

// src/helpers/factories/settingsDifferences/diffRegisterTicketFactory.ts
var TicketDisplayFieldLabels = /* @__PURE__ */ ((TicketDisplayFieldLabels2) => {
  TicketDisplayFieldLabels2[TicketDisplayFieldLabels2["showTimestamps"] = 0] = "showTimestamps";
  TicketDisplayFieldLabels2[TicketDisplayFieldLabels2["showSendCourseButton"] = 1] = "showSendCourseButton";
  TicketDisplayFieldLabels2[TicketDisplayFieldLabels2["displayDefaultModifiers"] = 2] = "displayDefaultModifiers";
  TicketDisplayFieldLabels2[TicketDisplayFieldLabels2["showModifierItemPrice"] = 3] = "showModifierItemPrice";
  TicketDisplayFieldLabels2[TicketDisplayFieldLabels2["hideModGroupTitles"] = 4] = "hideModGroupTitles";
  TicketDisplayFieldLabels2[TicketDisplayFieldLabels2["modifierItemDisplayMode"] = 5] = "modifierItemDisplayMode";
  TicketDisplayFieldLabels2[TicketDisplayFieldLabels2["autoCollapseLineItems"] = 6] = "autoCollapseLineItems";
  TicketDisplayFieldLabels2[TicketDisplayFieldLabels2["noForDeselectedDefaultModifiers"] = 7] = "noForDeselectedDefaultModifiers";
  TicketDisplayFieldLabels2[TicketDisplayFieldLabels2["addSubForMultiSelectOff"] = 8] = "addSubForMultiSelectOff";
  TicketDisplayFieldLabels2[TicketDisplayFieldLabels2["groupSameModItems"] = 9] = "groupSameModItems";
  TicketDisplayFieldLabels2[TicketDisplayFieldLabels2["separateSentItems"] = 10] = "separateSentItems";
  return TicketDisplayFieldLabels2;
})(TicketDisplayFieldLabels || {});
var returnLabel = (field) => {
  if (field in TicketDisplayFieldLabels) {
    return i18n_config_default.t(
      `app.modals.registerTicketDiffModal.ticketDisplay.${field}`
    );
  }
};
var diffRegisterTicketFactory = (diffArray) => {
  if (diffArray.length > 0) {
    const ticketDisplay = generateTicketDisplayObj(diffArray);
    return {
      ticketDisplay
    };
  }
  return null;
};
var generateTicketDisplayObj = (diffArray) => {
  const ticketDisplay = [];
  diffArray.forEach(
    (diff) => filterDiffFunction(
      diff,
      ({ field, diffLength, newDiff }) => {
        if (diffLength === 1) {
          if (field in TicketDisplayFieldLabels) {
            if (field === "modifierItemDisplayMode") {
              ticketDisplay.push(__spreadProps(__spreadValues({}, newDiff), {
                textValue: i18n_config_default.t(
                  `settingsModule.registerTicketSettings.ticketDisplay.modifiersDisplay.modifierItemDisplayMode.options.${newDiff.value}`
                )
              }));
            } else {
              ticketDisplay.push(newDiff);
            }
          }
        }
      },
      returnLabel
    )
  );
  return ticketDisplay;
};

export { diffRegisterTicketFactory };
